import * as React from "react";
import Grid from "@mui/material/Grid";
import MailIcon from "@mui/icons-material/Mail";
import {
  Alert,
  Autocomplete,
  Badge,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Modal,
  TextField,
  Tooltip,
  autocompleteClasses,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import WarningIcon from "@mui/icons-material/Warning";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { AppraisalValueTable } from "./AppraisalValues";
import { AppraisalAssetsList } from "./AppraisalAssetList";
import {
  AppraisalReviewServiceURL,
  DocumentServiceURL,
  InvestmentServiceURL,
  LookupServieURL,
  TaskmgmtServiceURL,
} from "../../../config/config";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { constants } from "buffer";
import { ServiceName } from "../../../constants";
import { useEffect, useState } from "react";
import { ViewTabList } from "../documents/ViewTabList";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import selectedInvestmentForAppraisalslice, {
  InvestmentNames,
  updateSelectedInvestmentForAppraisal,
} from "../../../redux/slices/selectedInvestmentForAppraisalslice";
import {
  UserContext,
  updateUserContext,
} from "../../../redux/slices/userContextSlice";
import axios, { AxiosResponse } from "axios";
import { wait } from "@testing-library/user-event/dist/utils";
import {
  AllCountriesModel,
  ApplicationUser,
  AppraisalAssetsModel,
  AppraisalsDetailsModelForEquity,
  DocumentTypesModel,
  ExternalAppraisersModel,
  InvestmentIDsModel,
  InvestmentForAppraisalModel,
  UserRoleMapModel,
  AppraisalDetailsModelForCM,
  AppraisalAttachment,
  UploadPreSignedPayloadModel,
  AppraisalDetailsModelForDLorDA,
  AppraisalModel,
  Appraisal,
  GetAppraisalModel,
  FileChunk,
} from "../../../all_Interfaces";
import { AlertDialog } from "../../util/Dialog";
import AppraisalDetailsForUSAppraisal, {
  updateAppraisalDetailsForUSAppraisal,
} from "../../../redux/slices/AppraisalDetailsForUSAppraisalSlice";
import { updateAppraisalAssets } from "../../../redux/slices/AppraisalAssetsSlice";
import { AppraisalValuesForCM } from "./AppraisalValuesForCM";
import { AppraisalValueTableForDLorDA } from "./AppraisalValuesDLorDA";
import { updateAppraisalDetailsForCM } from "../../../redux/slices/AppraisalDetailsForCMSlice";
import { updateAppraisalDetailsForDLorDA } from "../../../redux/slices/AppraisalDetailsForDLorDASlice";
import { DebtAssetsAssetList } from "./DebtAssetsAssetList";
import { ToastMessage } from "../../util/ToastMessage";
import { addNewAttachments } from "../../../redux/slices/AddNewAttachmentsSlice";
import { useNavigate } from "react-router-dom";
import { updateAttachments } from "../../../redux/slices/UpdateExistingAttachmentSlice";
import { updateappraisalSubmitEvent } from "../../../redux/slices/AppraisalSubmitEventSlice";
import { LiveTv, Message } from "@mui/icons-material";
import dayjs from "dayjs";
import { ArgusSupportBanner } from "../../util/ArgusSupportBanner";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};


const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const AppraisalFormNew = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const today = new Date();
  const [documentTypes, setDocumentTypes] = useState<DocumentTypesModel[]>([]);
  const [isSaveClicked, setIsSaveClicked] = useState<boolean>(false);
  const [appraisalType, setAppraisalType] = useState<string>("");
  const [openModel, setOpenModel] = useState<{ isOpen: boolean, message: string }>({ isOpen: false, message: "" });
  const [appraisalDataAfterSave, setAppraisalDataAfterSave] = useState<{ appraisalId: string, xmin: number }>({ appraisalId: "", xmin: 0 });
  const [appraisalDetailsFromInvestment, setAppraisalDetailsFromInvestment] =
    useState<{
      fund: string;
      assetManager: ApplicationUser;
      cityStateCountry: string;
      investmentType: string;
      city: string;
      hasDebtLiability: boolean;
      state: string;
      country: string;
    }>({
      fund: "",
      assetManager: {
        firstName: "",
        lastName: "",
        email: "",
      },
      cityStateCountry: "",
      city: "",
      state: "",
      country: "",
      investmentType: "",
      hasDebtLiability: false,
    });
    const allCountries = React.useRef<AllCountriesModel[]>([]);
  const [selectedExternalAppraiser, setSelectedExternalAppraiser] =
    useState<string>("");
  const [appraisalsDetailsRDX, setAppraisalDetailsRDX] =
    useState<AppraisalsDetailsModelForEquity>({
      currentAppraisalValue: null,
      effectiveDateOfValue: "",
      sheduled_n_cost: null,
      lastAppraisedValue: null,
      lastAppraisalPercentageChange: null,
      lastAppraisedDate: "",
      lastAnnualAppraisedValue: null,
      lastAnnualAppraisalPercentageChange: null,
      lastAnnualAppraisedDate: "",
      currencySelected: "",
      GPAppraisalValue: null,
    });
  const [appraisalDetailsForCMRDX, setAppraisalDetailsForCMRDX] =
    useState<AppraisalDetailsModelForCM>({
      currencySelected: "",
      propertyValueAsIs: null,
      propertyValueAsIsDate: "",
      capRateAsIs: null,
      propertyValueStabilized: null,
      propertyValueStabilizedDate: "",
      capRateStabilized: null,
      propertyInsurableValue: null,
      propertyLandValue: null,
      reportDate: "",
    });
  const [appraisalDetailsForDLorDARDX, setAppraisalDetailsForDLorDARDX] =
    useState<AppraisalDetailsModelForDLorDA>({
      currencySelected: "",
      currentDebtValue: null,
      currentPrincipalValue: null,
      loanToValueRatio: null,
      treasuryRate: null,
      riskPremium: null,
      surveyYield: null,
      currentEffectiveDate: "",
      derivative: null,
      lastDebtValue: null,
      lastDebtPercentageChange: null,
      lastDebtEffectiveDate: "",
    });

  const [externalAppraiserArray, setExternalAppraiserArray] = useState<
    string[]
  >([]);
  const [selectedAppraisalFirm, setSelectedAppraisalFirm] = useState<{
    label: string;
    value: string;
  }>({ label: "", value: "" });
  const [selectedValuationType, setSelectedValuationType] = useState<{
    label: string;
    value: string;
  }>({ label: "", value: "" });
  const [loading, setLoading] = useState<boolean>(false);
  const [fileMessage, setFileMessage] = useState<boolean>(false);
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  const fileSize = React.useRef<any>();
  const chunkSize = React.useRef<number>(1048576 * 3);
  const fileToBeUpload = React.useRef<any>();
  const chunkCount = React.useRef<any>();
  const chunk = React.useRef<any>();
  const fileGuid = React.useRef<any>();
  const counter = React.useRef<number>(1);
  const beginingOfTheChunk = React.useRef<number>(0);
  const endOfTheChunk = React.useRef<any>();
  const uploadStartResponse = React.useRef<any>();
  const largeFileCount = React.useRef<number>(0);

  const largeFileSuccessCount = React.useRef<number>(0);
  const largeFileFailedCount = React.useRef<number>(0);
  const [isSuccess, setIsSuccess] = useState<{
    isSuccess: boolean;
    message: string;
  }>({ isSuccess: false, message: "" });
  const [oldSelectedInvestment, setOldSelectedInvestment] =
    useState<InvestmentIDsModel | null>(null);
  const [newSelectedInvestment, setNewSelectedInvestment] =
    useState<InvestmentIDsModel | null>(null);
  const [firstLoadResults, setFirstLoadResults] = useState<{
    fundsUsersByUser: UserRoleMapModel[];
    investmentsByUser: InvestmentIDsModel[];
    allDocumentTypes: DocumentTypesModel[];
    allCountries: AllCountriesModel[];
    allExternalAppraisers: ExternalAppraisersModel[];
  }>({
    fundsUsersByUser: [] as UserRoleMapModel[],
    investmentsByUser: [] as InvestmentIDsModel[],
    allDocumentTypes: [] as DocumentTypesModel[],
    allCountries: [] as AllCountriesModel[],
    allExternalAppraisers: [] as ExternalAppraisersModel[],
  });
  const [investmentIdAndType, setInvestmentIdAndType] = useState<{
    investmentId: string;
    investmentType: string;
  }>({ investmentId: "", investmentType: "" });

  const [latestPendingAppraisal, setLatestPendingAppraisal] =
    useState<GetAppraisalModel>(new GetAppraisalModel());
  const [isPendingAppraisal, setIsPendingAppraisal] = useState<boolean>(false);
  const [allDocTypes, setAllDocTypes] = useState<DocumentTypesModel[]>([]);
  // const [isMortgage, setIsMortgage] = useState<boolean>(false);

  let isMortgage: boolean = false;
  const [appraisalFirms, setAppraisalFirms] = useState<
    { label: string; value: string }[]
  >([]);

  const [appraiser1List, setAppraiser1List] = useState<
    {
      firstName: string;
      lastName: string;
      email: string;
      name: string;
      userType: string;
    }[]
  >([]);
  const valuationTypeOptions = [
    { label: "Internal" , value: "Internal" },
    { label: "External" , value: "External" }
  ];
  const [selectedInvestment, setSelectedInvestment] =
    useState<InvestmentIDsModel | null>(null);
  const [isValuationTypeRequired, setIsValuationTypeRequired] = useState<boolean>(false);
  const [frequency, setFrequency] = useState<string>("");
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [attachments, setAttachments] = useState<AppraisalAttachment[]>([]);
  const [modifiedAsset, setModifiedAsset] = useState<AppraisalAssetsModel[]>(
    []
  );
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const userContext: UserContext = useAppSelector(
    (state) => state.UserContext.data
  );

  const appraisalDetails: AppraisalsDetailsModelForEquity = useAppSelector(
    (state) => state.AppraisalDetailsForUSAppraisal.data
  );
  const appraisalDetailsForCM: AppraisalDetailsModelForCM = useAppSelector(
    (state) => state.AppraisalDetailsForCM.data
  );

  const appraisalDetailsForDLorDA: AppraisalDetailsModelForDLorDA =
    useAppSelector((state) => state.AppraisalDetailsForDLorDA.data);

  const NewAttachmentList: AppraisalAttachment[] = useAppSelector(
    (state) => state.AddNewAttachments.data
  );

  const latestSelectedInvestment: InvestmentForAppraisalModel = useAppSelector(
    (state) => state.SelectedInvestmentForAppraisal.data
  );
  const modifiedAssets: AppraisalAssetsModel[] = useAppSelector(
    (state) => state.AppraisalAssets.data
  );
  // const selectedInvestment = useAppSelector(
  //   (state) => state.SelectedInvestmentForAppraisal?.data
  // );
  const [selectedAppraiser1, setSelectedAppraiser1] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    name: string;
    userType: string;
  }>({
    firstName: "",
    lastName: "",
    name: "",
    email: "",
    userType: "",
  });

  useEffect(() => {
    setModifiedAsset(modifiedAssets);
    console.log(modifiedAssets);
  }, [modifiedAssets]);

  useEffect(() => {
    setAttachments(NewAttachmentList);
    console.log(NewAttachmentList);
  }, [NewAttachmentList]);

  useEffect(() => {
    setAppraisalDetailsRDX(appraisalDetails);
  }, [appraisalDetails]);

  useEffect(() => {
    setAppraisalDetailsForCMRDX(appraisalDetailsForCM);
  }, [appraisalDetailsForCM]);

  useEffect(() => {
    setAppraisalDetailsForDLorDARDX(appraisalDetailsForDLorDA);
    console.log(appraisalDetailsForDLorDA);
  }, [appraisalDetailsForDLorDA]);

  // useEffect(() => {
  //   if (Object.keys(userContext).length == 0) {
  //     getProfile(true).then((data: any) => {
  //       dispatch(updateUserContext(data));
  //     });
  //   }
  // }, []);
  useEffect(() => {
    if (userContext.isAdmin || userContext.isAppraisal1 || userContext.isDebtAppraisal1) {
      dispatch(updateAppraisalDetailsForUSAppraisal(new AppraisalsDetailsModelForEquity()));
      dispatch(updateAppraisalDetailsForCM(new AppraisalDetailsModelForCM()));
      dispatch(updateAppraisalDetailsForDLorDA(new AppraisalDetailsModelForDLorDA()));
      dispatch(updateAppraisalAssets([] as AppraisalAssetsModel[]));
      dispatch(updateappraisalSubmitEvent(false));
      fetchData();
    } else {
      navigate("/unauthorized");
    }
  }, [userContext]);

  console.log(appraisalDetails);
  console.log(appraisalDetailsForCM);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const submitEvent: boolean = useAppSelector(
    (state) => state.AppraisalSubmitEvent.data
  );

  useEffect(() => {
    setIsSubmit(submitEvent);
  }, [submitEvent]);

  const fetchData = async () => {
    dispatch(addNewAttachments([] as AppraisalAttachment[]));
    dispatch(updateAttachments([] as AppraisalAttachment[]));
    try {
      setLoading(true);
      const [call1, call2, call3, call4, call5] = await Promise.all([
        getApiCall(
          TaskmgmtServiceURL +
          "/userrolemaps/GetFundsByUser?email=" +
          currentUserData.email?.toLowerCase(),
          ServiceName.TASKMANAGEMENTSERVICE
        ),
        getApiCall(
          InvestmentServiceURL +
          "/investments/getinvestmentbyuser?emailAddress=" +
          currentUserData.email,
          ServiceName.INVESTMENTSERVICE
        ),
        getApiCall(
          LookupServieURL + "/DocumentTypes/GetAll",
          ServiceName.LOOKUPSERVICE
        ),
        getApiCall(
          LookupServieURL + "/DocumentTypes/GetAllCountries",
          ServiceName.LOOKUPSERVICE
        ),
        getApiCall(
          LookupServieURL + "/externalappraisers/getall",
          ServiceName.LOOKUPSERVICE
        ),
      ]);
      var docArray: DocumentTypesModel[] = [...(call3 as any).result];
      // docArray.push({id:0,
      //   name:"All",
      //   tag:"string",
      //   appraisalCycle:"string",
      //   investmentType:"string",
      //   sortOrder:0,
      //   region:"string"});

      setFirstLoadResults({
        fundsUsersByUser: (call1 as any).result,
        investmentsByUser: (call2 as any).result.sort((a: any, b: any) =>
          a.investmentId > b.investmentId ? 1 : -1
        ),
        allDocumentTypes: docArray.sort((a: any, b: any) =>
          a.id > b.id ? 1 : -1
        ),
        allCountries: (call4 as any).result,
        allExternalAppraisers: (call5 as any).result,
      });
      allCountries.current = (call4 as any).result;
      setAllDocTypes(docArray.sort((a: any, b: any) => (a.id > b.id ? 1 : -1)));
      setDocumentTypes(
        docArray.sort((a: any, b: any) => (a.id > b.id ? 1 : -1))
      );

      //filtering the firms for firm autocomplete options
      let firmsArray: string[] = (call5 as any).result
        .map((d: ExternalAppraisersModel) => d.appraisalFirm)
        .filter(function (elem: any, index: any, self: string | any[]) {
          return index === self.indexOf(elem);
        })
        .filter((item: any) => item !== null);

      var tempFirmsArray: { label: string; value: string }[] = firmsArray
        .map((a) => {
          return { label: a, value: a };
        })
        .sort((a: any, b: any) => {
          if (b.value == null) return 1;
          return a.label > b.label ? 1 : -1;
        })
        .slice();

      setAppraisalFirms(tempFirmsArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      wait(1000).then(() => {
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    if (selectedInvestment != null && selectedInvestment != undefined) {
      isMortgage = false;
      setInvestmentIdAndType({
        investmentId: selectedInvestment.investmentId,
        investmentType: selectedInvestment.investmentType,
      });

      if (selectedInvestment.investmentType.toLowerCase() === "mortgage") {
        isMortgage = true;
      }
      var investmentDetailsFromInvservice: InvestmentForAppraisalModel;
      const getInvestmentData = async () => {
        if (selectedInvestment.investmentType.toLowerCase() != "mortgage") {
          dispatch(updateAppraisalAssets([] as AppraisalAssetsModel[]));
        }

        try {
          setLoading(true);
          await getApiCall(
            InvestmentServiceURL +
            "/investments/GetByIdWithActiveAssets?id=" +
            selectedInvestment.investmentId,
            ServiceName.INVESTMENTSERVICE
          ).then((data: any) => {
            investmentDetailsFromInvservice = data?.result;
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          wait(1000).then(() => {
            setLoading(false);
            dispatch(
              updateSelectedInvestmentForAppraisal(
                investmentDetailsFromInvservice
              )
            );
            populateFieldBasedOnInvestment(investmentDetailsFromInvservice);
          });
        }


        try {
          setLoading(true);
          await getApiCall(
            TaskmgmtServiceURL +
            "/FundConfigurations/GetFundConfigurationByFundIdAndInvestmentType?strFundId=" +
            selectedInvestment.fundId+
            "&strInvestmentType=" +
            selectedInvestment.investmentType,
            ServiceName.TASKMANAGEMENTSERVICE
          ).then((data: any) => {
            setIsValuationTypeRequired(data?.result.isValuationTypeRequired);
            setFrequency(data?.result.appraisalSchedule || "");
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        }

      };
      getInvestmentData();
    }
  }, [selectedInvestment]);

  const populateFieldBasedOnInvestment = (
    investmentDetailsFromInvservice: InvestmentForAppraisalModel
  ) => {
    dispatch(addNewAttachments([] as AppraisalAttachment[]));
    dispatch(updateAttachments([] as AppraisalAttachment[]));
    var investmentType = investmentDetailsFromInvservice.investmentType;
    var fund =
      investmentDetailsFromInvservice.fundId +
      " : " +
      investmentDetailsFromInvservice.fund;

    var lastAppraisedValue =
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastAppraisedValue === null
        ? null
        : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
          .lastAppraisedValue;
    var lastAnnualAppraisedValue =
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastAnnualAppraisedValue === null
        ? null
        : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
          .lastAnnualAppraisedValue;
    if (
      investmentDetailsFromInvservice.investmentType.toLowerCase() ===
      "debt asset"
    ) {
      isMortgage = false;
      setAppraisalType("DA");
      setSelectedAppraisalFirm({ label: "Nuveen", value: "Nuveen" });
      setSelectedExternalAppraiser("N/A");

      // this.fgAppraisalForm.get('scheduleNCost').setErrors(null);
    } else if (
      investmentDetailsFromInvservice.investmentType.toLowerCase() === "equity"
    ) {
      isMortgage = false;
      if (
        investmentDetailsFromInvservice.fgInvestmentAppraisalValues
          .lastAppraisedValue != 0 && investmentDetailsFromInvservice.fgInvestmentAppraisalValues
            .lastAppraisedValue != null
      ) {
        setAppraisalType("I");
      } else {
        setAppraisalType("1A");
      }
    } else if (
      investmentDetailsFromInvservice.investmentType.toLowerCase() ===
      "mortgage"
    ) {
      isMortgage = true;
      setAppraisalType("CM");
    }

    let cityStateCountry: string = "";
    cityStateCountry =
      investmentDetailsFromInvservice.city != undefined &&
        investmentDetailsFromInvservice.city != ""
        ? investmentDetailsFromInvservice.city
        : cityStateCountry;

    cityStateCountry =
      investmentDetailsFromInvservice.state != undefined &&
        investmentDetailsFromInvservice.state != ""
        ? cityStateCountry + ", " + investmentDetailsFromInvservice.state
        : cityStateCountry;

    cityStateCountry =
      isMortgage &&
        investmentDetailsFromInvservice.country != undefined &&
        investmentDetailsFromInvservice.country != ""
        ? cityStateCountry + ", " + investmentDetailsFromInvservice.country
        : cityStateCountry;
    // this.fgAppraisalForm.get("isInvestmentHasDebtLiability").setValue(this.isNewDL ? false : objInvestment.hasDebtLiability);

    var lastAppraisedDate =
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastAppraisalDate === "" ||
        investmentDetailsFromInvservice.fgInvestmentAppraisalValues
          .lastAppraisalDate == null
        ? ""
        : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
          .lastAppraisalDate;
    var lastAnnualAppraisedDate =
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastAnnualAppraisalDate === "" ||
        investmentDetailsFromInvservice.fgInvestmentAppraisalValues
          .lastAnnualAppraisalDate == null
        ? ""
        : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
          .lastAnnualAppraisalDate;
    setAppraisalDetailsFromInvestment({
      ...appraisalDetailsFromInvestment,
      fund: fund,
      investmentType: investmentType,
      assetManager:
        investmentDetailsFromInvservice.assetManager != null
          ? investmentDetailsFromInvservice.assetManager
          : { firstName: "", lastName: "", email: "" },
      cityStateCountry: cityStateCountry,
      hasDebtLiability: investmentDetailsFromInvservice.hasDebtLiability,
      city: investmentDetailsFromInvservice.city,
      state: investmentDetailsFromInvservice.state,
      country: investmentDetailsFromInvservice.country,
    });
    if (
      investmentDetailsFromInvservice.investmentType.toLowerCase() ===
      "mortgage"
    ) {
      var tempDocTypes: DocumentTypesModel[] = [...documentTypes];
      setDocumentTypes(
        tempDocTypes.filter(
          (doc: DocumentTypesModel) => doc.name !== "Debt Record"
        )
      )
      

      dispatch(
        updateAppraisalDetailsForCM({
          currencySelected: "",
          propertyValueAsIs: null,
          propertyValueAsIsDate: "",
          capRateAsIs: null,
          propertyValueStabilized: null,
          propertyValueStabilizedDate: "",
          capRateStabilized: null,
          propertyInsurableValue: null,
          propertyLandValue: null,
          reportDate: "",
        })
      );
    }
    if (
      investmentDetailsFromInvservice.investmentType.toLowerCase() === "equity"
    ) {
      var tempDocTypes: DocumentTypesModel[] = [...documentTypes];
      setDocumentTypes(
        tempDocTypes.filter(
          (doc: DocumentTypesModel) => doc.name !== "Debt Record"
        )
      );
      dispatch(
        updateAppraisalDetailsForUSAppraisal({
          currentAppraisalValue: null,
          effectiveDateOfValue: dayjs(today).format("MM-DD-YYYY"),
          sheduled_n_cost: null,
          lastAppraisalPercentageChange: null,
          lastAppraisedValue: lastAppraisedValue,
          lastAnnualAppraisedValue: lastAnnualAppraisedValue,
          lastAppraisedDate: lastAppraisedDate,
          lastAnnualAppraisedDate: lastAnnualAppraisedDate,
          currencySelected: "",
          lastAnnualAppraisalPercentageChange: null,
          GPAppraisalValue: null,
        })
      );
    }

    if (
      investmentDetailsFromInvservice.investmentType.toLowerCase() ===
      "debt asset"
    ) {
      dispatch(
        updateAppraisalDetailsForDLorDA({
          currencySelected: "",
          currentDebtValue: null,
          currentPrincipalValue: null,
          loanToValueRatio: null,
          treasuryRate: null,
          riskPremium: null,
          surveyYield: null,
          currentEffectiveDate: dayjs(today).format("MM-DD-YYYY"),
          derivative: null,
          lastDebtValue: lastAppraisedValue,
          lastDebtPercentageChange: null,
          lastDebtEffectiveDate: lastAppraisedDate,
        })
      );
    }

    if (
      investmentDetailsFromInvservice.investmentType.toLowerCase() != "mortgage"
    ) {
      dispatch(updateAppraisalAssets(investmentDetailsFromInvservice.assets));
    }

    let tempAppraiser1: {
      firstName: string;
      lastName: string;
      email: string;
      name: string;
      userType: string;
    }[] = [];
    let arrTempAppraiser1Email: string[] = [];

    if (userContext.isAdmin) {
      firstLoadResults.fundsUsersByUser.forEach((user: UserRoleMapModel) => {
        const email = user.email.toLowerCase();
        if (user.email && arrTempAppraiser1Email.indexOf(email) == -1) {
          arrTempAppraiser1Email.push(email);
          tempAppraiser1.push({
            firstName: user.firstName,
            lastName: user.lastName,
            name: user.firstName + " " + user.lastName,
            email: email,
            userType: user.userType,
          });
        }
      });
    } else {
      firstLoadResults.fundsUsersByUser.forEach((user: UserRoleMapModel) => {
        let arrCurrentFund = user.fundId.split(";");
        if (arrCurrentFund.indexOf(investmentDetailsFromInvservice.fundId) >= 0 && user.email) {
          const email = user.email.toLowerCase();
          if (user.email && arrTempAppraiser1Email.indexOf(email) == -1) {
            arrTempAppraiser1Email.push(email);
            tempAppraiser1.push({
              firstName: user.firstName,
              lastName: user.lastName,
              name: user.firstName + " " + user.lastName,
              email: email,
              userType: user.userType,
            });
          }
        }
      });
    }

    setAppraiser1List(
      tempAppraiser1
        .sort((a: any, b: any) => (a.firstName > b.firstName ? 1 : -1))
        .slice()
    );

    let currentUserIndex: number = tempAppraiser1.findIndex(
      (x) => x.email === userContext.email.toLowerCase()
    );
    if (currentUserIndex != -1) {
      setSelectedAppraiser1(tempAppraiser1[currentUserIndex]);
    }
  };

  const handleInvalidClose = () => {
    setSelectedInvestment(null);
    setNewSelectedInvestment(null);
    setSelectedAppraisalFirm({ label: "", value: "" });
    setAppraisalType("");
    setSelectedExternalAppraiser("");
    setDocumentTypes([...allDocTypes]);

    setAppraisalDetailsFromInvestment({
      fund: "",
      investmentType: "",
      assetManager: { firstName: "", lastName: "", email: "" },
      cityStateCountry: "",
      hasDebtLiability: false,
      city: "",
      state: "",
      country: "",
    });

    dispatch(
      updateAppraisalDetailsForCM({
        currencySelected: "",
        propertyValueAsIs: null,
        propertyValueAsIsDate: "",
        capRateAsIs: null,
        propertyValueStabilized: null,
        propertyValueStabilizedDate: "",
        capRateStabilized: null,
        propertyInsurableValue: null,
        propertyLandValue: null,
        reportDate: "",
      })
    );

    dispatch(
      updateAppraisalDetailsForUSAppraisal({
        currentAppraisalValue: null,
        effectiveDateOfValue: "",
        sheduled_n_cost: null,
        lastAppraisalPercentageChange: null,
        lastAppraisedValue: null,
        lastAnnualAppraisedValue: null,
        lastAppraisedDate: "",
        lastAnnualAppraisedDate: "",
        currencySelected: "",
        lastAnnualAppraisalPercentageChange: null,
        GPAppraisalValue: null,
      })
    );

    dispatch(
      updateAppraisalDetailsForDLorDA({
        currencySelected: "",
        currentDebtValue: null,
        currentPrincipalValue: null,
        loanToValueRatio: null,
        treasuryRate: null,
        riskPremium: null,
        surveyYield: null,
        currentEffectiveDate: "",
        derivative: null,
        lastDebtValue: null,
        lastDebtPercentageChange: null,
        lastDebtEffectiveDate: "",
      })
    );

    dispatch(updateAppraisalAssets([] as AppraisalAssetsModel[]));
    setSelectedAppraiser1({
      firstName: "",
      lastName: "",
      email: "",
      name: "",
      userType: "",
    });

    setIsPendingAppraisal(false);
    setLatestPendingAppraisal(new GetAppraisalModel());
    dispatch(addNewAttachments([] as AppraisalAttachment[]));
    dispatch(updateAttachments([] as AppraisalAttachment[]));
  };

  const handleAppraiser1Change = (appraiser1: {
    firstName: string;
    lastName: string;
    email: string;
    name: string;
    userType: string;
  }) => {
    setSelectedAppraiser1(appraiser1);
  };

  const checkExistingPendingAppraisals = async (
    invType: string,
    invId: string
  ) => {
    var flag: boolean = false;
    await getApiCall(
      AppraisalReviewServiceURL +
      "/appraisals/GetPendingAppraisalByInvestment?investmentId=" +
      invId +
      "&investmentType=" +
      invType,
      ServiceName.APPRAISALREVIEW
    ).then((data: any) => {
      var pendingCount: number = data.result.length;
      if (pendingCount > 0) {
        flag = true;
        setIsPendingAppraisal(true);
        setLatestPendingAppraisal(data.result[0]);
      }
    });
    return flag;
  };

  useEffect(() => {
    console.log(latestPendingAppraisal);
  }, [latestPendingAppraisal])

  const handleInvestmentChange = async (
    userSelectedInvestment: InvestmentIDsModel
  ) => {

    setIsPendingAppraisal(false);
    setLatestPendingAppraisal(new GetAppraisalModel());
    setSelectedAppraisalFirm({ label: "", value: "" });
    setSelectedExternalAppraiser("");
    setSelectedAppraiser1({
      firstName: "",
      lastName: "",
      email: "",
      name: "",
      userType: "",
    });
    await checkExistingPendingAppraisals(
      userSelectedInvestment.investmentType,
      userSelectedInvestment.investmentId
    );

    if (selectedInvestment === null) {
      console.log(userSelectedInvestment);
      setSelectedInvestment(userSelectedInvestment);
    } else {
      setNewSelectedInvestment(userSelectedInvestment);
      setOpenDialog(true);
    }
  };

  const handleFirmChangeChange = (arselectedFirm: {
    label: string;
    value: string;
  }) => {
    setSelectedAppraisalFirm(arselectedFirm);
    var users: string[] = [];
    firstLoadResults.allExternalAppraisers.forEach(
      (appraiser: ExternalAppraisersModel) => {
        if (appraiser.appraisalFirm === arselectedFirm.value) {
          users.push(appraiser.name);
        }
      }
    );
    setExternalAppraiserArray(users);
  };

  const handleValuationTypeChange = (arselectedValutionType: {
    label: string;
    value: string;
  }) => {
    setSelectedValuationType(arselectedValutionType);
  };

  

  const closeDialog = () => {
    setNewSelectedInvestment(null);
    setOpenDialog(false);
  };


  const handleConfirm = () => {
    setSelectedInvestment(newSelectedInvestment);
    setOpenDialog(false);
    dispatch(updateAppraisalDetailsForUSAppraisal(new AppraisalsDetailsModelForEquity()));
    dispatch(updateAppraisalDetailsForCM(new AppraisalDetailsModelForCM()));
    dispatch(updateAppraisalDetailsForDLorDA(new AppraisalDetailsModelForDLorDA()));
    dispatch(updateAppraisalAssets([] as AppraisalAssetsModel[]));
    dispatch(addNewAttachments([] as AppraisalAttachment[]));
    dispatch(updateAttachments([] as AppraisalAttachment[]));
  };

  function handleExternalAppraiserChange(name: string) {
    setSelectedExternalAppraiser(name);
  }
  
  const resetChunkProperties = () => {
    //setShowProgress(true);
    //setProgress(0);
    setCounter(1);
    beginingOfTheChunk.current = 0;
    endOfTheChunk.current = chunkSize.current;
  }

  const setCounter = (counterr: number) => {
    counter.current = counterr;
  }

  const submitAttachment = async (appraisalId: string, btnEvent: string) => {
    // attachments.forEach(async (file: AppraisalAttachment) => {
    //   var tempFilePayload = new UploadPreSignedPayloadModel();
    //   tempFilePayload.doctype = file.doctype;
    //   tempFilePayload.fileAsBase64 = file.fileAsBase64;
    //   tempFilePayload.fileName = file.fileName;
    //   tempFilePayload.fileSize = file.fileSize;
    //   tempFilePayload.fileType = file.fileType;
    //   tempFilePayload.guid = appraisalId;
    //   tempFilePayload.lastModifiedBy = file.lastModifiedBy;
    //   tempFilePayload.lastModifiedDate = file.lastModifiedDate;
    //   tempFilePayload.lastModifiedTime = file.lastModifiedTime;

    //   const key: string = appraisalId + "_" + file.doctype + "_" + file.fileName;

    //   const payload = { TggingKey: key, Attachement: tempFilePayload };
    //   setFileMessage(true);
    //   await postApiCall(
    //     DocumentServiceURL + "/Documents/GetUploadPreSignedURL",
    //     tempFilePayload,
    //     ServiceName.DOCUMENTSERVICE
    //   ).then(async (data) => {
    //     try {
    //       return await axios
    //         .put(data as string, file.file, {
    //           headers: {
    //             "Content-Type": file.fileType
    //           },
    //         })
    //         .then(async (data: any) => {
    //           return await postApiCall(
    //             DocumentServiceURL + "/Documents/AddTggingByKey",
    //             payload,
    //             ServiceName.DOCUMENTSERVICE
    //           ).then((data) => {
    //             console.log("File uploaded successfully!");
    //             setIsSuccess({ isSuccess: true, message: `Appraisal has been ${btnEvent == 'submit' ? 'submitted' : 'saved'}` });

    //             return data;
    //           })
    //         });
    //     } catch (error) {
    //       setLoading(true);
    //       setIsError({ isError: true, message: 'Error uploading file' });
    //       console.error("Error uploading file: ", error);
    //     } finally {
    //       setFileMessage(false);
    //       wait(3000).then(() => {
    //         setIsSuccess({ isSuccess: false, message: '' });
    //         setIsError({ isError: false, message: '' });
    //         navigate("/main/appraisal-form/edit/" + appraisalId);

    //       })
    //     }

    //     console.log(data);
    //   });
    // });
  
    let observableBatch:any = [];
    var tempAttachments = [...attachments];


		for (let i = 0; i < tempAttachments.length; i++) {
      setFileMessage(true);
      const currentUtcDate = new Date(Date.parse(tempAttachments[i].lastModifiedDate.toUTCString()));
      var tempFilePayload = new UploadPreSignedPayloadModel();
      tempFilePayload.doctype = tempAttachments[i].doctype;
      tempFilePayload.fileAsBase64 = tempAttachments[i].fileAsBase64;
      tempFilePayload.fileName = tempAttachments[i].fileName;
      tempFilePayload.fileSize = tempAttachments[i].fileSize;
      tempFilePayload.fileType = tempAttachments[i].fileType;
      tempFilePayload.guid =  appraisalId;
      tempFilePayload.lastModifiedBy = tempAttachments[i].lastModifiedBy;
      tempFilePayload.lastModifiedDate = currentUtcDate;
      tempFilePayload.lastModifiedTime = tempAttachments[i].lastModifiedTime;


			tempAttachments[i].guid = appraisalId;
			if (tempFilePayload.fileSize < 26000000) {
				observableBatch.push(postApiCall(DocumentServiceURL + "/Documents/add",tempFilePayload,ServiceName.DOCUMENTSERVICE));
			}
			else {

				largeFileCount.current++;
				await startFileChunkUpload(tempFilePayload);
			}
		}

		Promise.all(observableBatch).then(async data => {
			console.log("Direct upload document was saved Successfully", data);

			//this.docTypes = data;

			await waitForLargeFileToBeUploaded(btnEvent,appraisalId);

			//return data;

		},
			error => {

				console.log(error);
				return error;
			});
  };

  const startFileChunkUpload = async (file:any) => {

		fileSize.current = file.fileSize;

		const _totalCount = fileSize.current % chunkSize.current == 0 ? fileSize.current / chunkSize.current : Math.floor(fileSize.current / chunkSize.current) + 1; // Total count of chunks will have been upload to finish the file
		chunkCount.current = _totalCount;

		//let tmpDirectoryName = {tmpDirectoryName:file.guid};
		let chunkFile = new FileChunk();
		chunkFile.fileAsBase64 = "";

		chunkFile.tmpDirectory = file.guid;
		chunkFile.fileName = file.fileName;

		return await postApiCall(DocumentServiceURL + "/Documents/start",chunkFile,ServiceName.DOCUMENTSERVICE).then(async (data: any) => {
				console.log('success', data);
				uploadStartResponse.current = data;
				await fileUpload(file, uploadStartResponse.current);

				return uploadStartResponse.current;
			}
		).catch((e:any)=> {
      console.log("Chunk Upload error ",e);
      
    }).then((d:any)=>{
      console.log("Complete");
    });
	}

  const fileUpload = async (file, uploadStartResponse) => {
		endOfTheChunk.current = chunkSize.current ;
		while (beginingOfTheChunk.current  <= file.fileAsBase64.length) {

			var chunk = file.fileAsBase64.slice(beginingOfTheChunk.current , endOfTheChunk.current );

      const currentUtcDate = new Date(Date.parse(file.lastModifiedDate.toUTCString()));
			let chunkFile = new FileChunk();
			chunkFile.fileAsBase64 = chunk;

			chunkFile.tmpDirectory = uploadStartResponse.tmpDirectoryName;
			chunkFile.fileName = file.fileName;
			chunkFile.fileSize = file.size;
			chunkFile.lastModifiedTime = file.lastModifiedTime;
			chunkFile.lastModifiedDate = currentUtcDate;
			chunkFile['estUploadDate'] = file.estUploadDate;
			chunkFile.lastModifiedBy = file.lastModifiedBy;
			chunkFile.fileIndex = counter.current;

			let responseData = await uploadChunk(chunkFile);

			setCounter(counter.current  + 1);
			beginingOfTheChunk.current  = endOfTheChunk.current ;
			endOfTheChunk.current  = endOfTheChunk.current  + chunkSize.current ;

		}
		uploadCompleted(uploadStartResponse, file);

	}

  const uploadChunk = async (chunkFile: any): Promise<any> => {
		try {

			return await postApiCall(DocumentServiceURL + "/Documents/chunk",chunkFile,ServiceName.DOCUMENTSERVICE).then(
				(data:any) => {
					console.log('success', data);
					return true;
				},
				(error:any) => {
					console.error('error', error);
					return false;

				}
			);


		} catch (error) {

			console.log('error', error)
		}
	}


  const uploadCompleted = async (uploadStartResponse, file)  => {
		let chunkFile = new FileChunk();
		chunkFile.fileAsBase64 = "";
    const currentUtcDate = new Date(Date.parse(file.lastModifiedDate.toUTCString()));
		chunkFile.tmpDirectory = uploadStartResponse.tmpDirectoryName;
		chunkFile.fileName = file.fileName;
		chunkFile.guid = file.guid;
		chunkFile.doctype = file.doctype;
		chunkFile.fileSize = file.fileSize;

		chunkFile.lastModifiedTime = file.lastModifiedTime;
		chunkFile.lastModifiedDate = currentUtcDate;
		chunkFile.lastModifiedBy = file.lastModifiedBy;


		return await postApiCall(DocumentServiceURL + "/Documents/end",chunkFile,ServiceName.DOCUMENTSERVICE).then( (data: any) => {
				console.log('success', data);
				let uploadEndResponse = data;
				largeFileSuccessCount.current++;
				return data;

			}
      // ,
			// error: (error: any) => {
			// 	console.error('error', error);
			// 	this.largeFileFailedCount++;
			// 	return error;

			// }
		).catch((e:any)=> {
      console.log("Chunk Upload error ",e);
      
    }).then((d:any)=>{
      console.log("Complete");
    });
	}


  const waitForLargeFileToBeUploaded = async (btnEvent,appraisalId) => {
		while (largeFileCount.current != largeFileSuccessCount.current + largeFileFailedCount.current) {
			await wait(2000);
		}
		setIsSuccess({ isSuccess: true, message: `Appraisal has been ${btnEvent == 'submit' ? 'submitted' : 'saved'}` });
    wait(5000).then(() => {
          setFileMessage(false);
              setIsSuccess({ isSuccess: false, message: '' });
              setIsError({ isError: false, message: '' });
              navigate("/main/appraisal-form/edit/" + appraisalId);
            }); 
	}


  const addDataToDB = async (btnEvent: string) => {
    var appraisalObj = new AppraisalModel();
    if (appraisalDataAfterSave.appraisalId != "" && appraisalDataAfterSave.xmin != 0) {
      appraisalObj.AppraisalId = appraisalDataAfterSave.appraisalId;
      appraisalObj.Xmin = appraisalDataAfterSave.xmin;
    }
    if (btnEvent == "save") {
      appraisalObj.Status = "New";
    }
    if (btnEvent == "submit") {
      appraisalObj.Status = "Submit";
    }
    appraisalObj.InvestmentId = latestSelectedInvestment.investmentId;
    appraisalObj.AppraisalType = appraisalType;
    var appraiser1FirstName =
      selectedAppraiser1.firstName != null ? selectedAppraiser1.firstName : "";
    var appraiser1LastName =
      selectedAppraiser1.lastName != null ? selectedAppraiser1.lastName : "";
    var appraiser1email =
      selectedAppraiser1.email != null ? selectedAppraiser1.email : "";
    appraisalObj.Appraiser1 = {
      firstName: appraiser1FirstName,
      lastName: appraiser1LastName,
      email: appraiser1email,
    };
    appraisalObj.Appraiser2 = {
      firstName: "",
      lastName: "",
      email: "",
    };
    appraisalObj.Appraiser3 = {
      firstName: "",
      lastName: "",
      email: "",
    };
    appraisalObj.Fiduciary = {
      firstName: "",
      lastName: "",
      email: "",
    };
    appraisalObj.AppraiserFirm = selectedAppraisalFirm.label;
    appraisalObj.ValuationType = selectedValuationType.label;
    appraisalObj.AssetManager = {
      ...appraisalDetailsFromInvestment.assetManager,
    };
    appraisalObj.City = appraisalDetailsFromInvestment.city;
    appraisalObj.State = appraisalDetailsFromInvestment.state;
    appraisalObj.Country = appraisalDetailsFromInvestment.country;
    appraisalObj.ExternalAppraiser = selectedExternalAppraiser;
    appraisalObj.Fund = appraisalDetailsFromInvestment.fund
      .split(":")[1]
      .trim();
    appraisalObj.FundId = appraisalDetailsFromInvestment.fund
      .split(":")[0]
      .trim();
    appraisalObj.HasDebtLiability =
      appraisalDetailsFromInvestment.hasDebtLiability;
    appraisalObj.InvestmentName = latestSelectedInvestment.name;

    appraisalObj.AssetManagerHead = latestSelectedInvestment.assetManagerHead;
    appraisalObj.InvestmentPropertyType = latestSelectedInvestment.propertyType;
    appraisalObj.InvestmentType = latestSelectedInvestment.investmentType;
    appraisalObj.PortfolioManager = latestSelectedInvestment.portfolioManager;
    appraisalObj.SectorHead = latestSelectedInvestment.sectorHead;
    appraisalObj.CreatedBy = userContext.firstName + " " + userContext.lastName;
    appraisalObj.CanSubmit = true;
    appraisalObj.Frequency = frequency;

    var selectedInvType =
      latestSelectedInvestment.investmentType !== null
        ? latestSelectedInvestment.investmentType.toLowerCase()
        : "";
    if (selectedInvType === "equity") {
      appraisalObj.Currency = appraisalsDetailsRDX.currencySelected;
      appraisalObj.CurrentAppraisalValue =
        appraisalsDetailsRDX.currentAppraisalValue;
      appraisalObj.ValueDate = //new Date(
        appraisalsDetailsRDX.effectiveDateOfValue
      //);
      appraisalObj.ScheduleNCost = appraisalsDetailsRDX.sheduled_n_cost;
      appraisalObj.LastAppraisedValue = appraisalsDetailsRDX.lastAppraisedValue;
      appraisalObj.LastAppraisalDate = appraisalsDetailsRDX.lastAppraisedDate;
      appraisalObj.LastAnnualAppraisedValue =
        appraisalsDetailsRDX.lastAnnualAppraisedValue;
      appraisalObj.LastAnnualAppraisalDate =
        appraisalsDetailsRDX.lastAnnualAppraisedDate;
      appraisalObj.GPAppraisalValue =
        appraisalsDetailsRDX.GPAppraisalValue;
      appraisalObj.PercentageChange = appraisalsDetailsRDX.lastAppraisalPercentageChange != "Infinity" && appraisalsDetailsRDX.lastAppraisalPercentageChange != "NaN" ? appraisalsDetailsRDX.lastAppraisalPercentageChange : null ;
      appraisalObj.AnnualPercentageChange = appraisalsDetailsRDX.lastAnnualAppraisalPercentageChange != "Infinity" &&  appraisalsDetailsRDX.lastAnnualAppraisalPercentageChange != "NaN" ? appraisalsDetailsRDX.lastAnnualAppraisalPercentageChange : null;
    }

    if (selectedInvType === "debt asset") {
      appraisalObj.Currency = appraisalDetailsForDLorDARDX.currencySelected;
      appraisalObj.CurrentAppraisalValue =
        appraisalDetailsForDLorDARDX.currentDebtValue;
        appraisalObj.currentPrincipalValue = appraisalDetailsForDLorDARDX.currentPrincipalValue;
        appraisalObj.loanToValueRatio = appraisalDetailsForDLorDARDX.loanToValueRatio != null ? Number(appraisalDetailsForDLorDARDX.loanToValueRatio?.toString().replaceAll(",","")).toFixed(2) : null ;
        appraisalObj.treasuryRate = appraisalDetailsForDLorDARDX.treasuryRate != null ? Number(appraisalDetailsForDLorDARDX.treasuryRate?.toString().replaceAll(",","")).toFixed(2) : null ;
        appraisalObj.riskPremium = appraisalDetailsForDLorDARDX.riskPremium != null ? Number(appraisalDetailsForDLorDARDX.riskPremium?.toString().replaceAll(",","")).toFixed(2) : null ;
        appraisalObj.surveyYield = appraisalDetailsForDLorDARDX.surveyYield != null ? Number(appraisalDetailsForDLorDARDX.surveyYield?.toString().replaceAll(",","")).toFixed(2) : null ;
      appraisalObj.ValueDate = //new Date(
        appraisalDetailsForDLorDARDX.currentEffectiveDate
      // );
      appraisalObj.Derivative = Number(appraisalDetailsForDLorDARDX.derivative?.toString().replaceAll(",",""));
      appraisalObj.LastAppraisedValue = appraisalDetailsForDLorDARDX.lastDebtValue;
      appraisalObj.LastAppraisalDate =
        appraisalDetailsForDLorDARDX.lastDebtEffectiveDate;
      appraisalObj.PercentageChange = appraisalDetailsForDLorDARDX.lastDebtPercentageChange  != "Infinity" && appraisalDetailsForDLorDARDX.lastDebtPercentageChange  != "NaN" ? appraisalDetailsForDLorDARDX.lastDebtPercentageChange : null;
    }

    if (selectedInvType === "mortgage") {
      appraisalObj.Currency = appraisalDetailsForCMRDX.currencySelected;
      appraisalObj.PropertyValueAsIs =
        appraisalDetailsForCMRDX.propertyValueAsIs;
      appraisalObj.CapRateAsIs = appraisalDetailsForCMRDX.capRateAsIs;
      appraisalObj.PropertyValueAsIsDate =
        appraisalDetailsForCMRDX.propertyValueAsIsDate;
      appraisalObj.PropertyValueStabilized =
        appraisalDetailsForCMRDX.propertyValueStabilized;
      appraisalObj.PropertyValueStabilizedDate =
        appraisalDetailsForCMRDX.propertyValueStabilizedDate;
      appraisalObj.CapRateStabilized =
        appraisalDetailsForCMRDX.capRateStabilized;
      appraisalObj.PropertyInsurableValue =
        appraisalDetailsForCMRDX.propertyInsurableValue;
      appraisalObj.PropertyLandValue =
        appraisalDetailsForCMRDX.propertyLandValue;
      appraisalObj.ReportDate = appraisalDetailsForCMRDX.reportDate;
      appraisalObj.CurrentAppraisalValue = 0;
      appraisalObj.ValueDate = new Date();
    }

    appraisalObj.Assets = modifiedAsset;
    var receivedAppraisalId;

    try {
      setLoading(true);
      await postApiCall(
        AppraisalReviewServiceURL + "/appraisals/" + btnEvent,
        appraisalObj,
        ServiceName.APPRAISALREVIEW
      ).then(async (data: any) => {
        console.log(data.result);

        if (btnEvent == "save") {
          setAppraisalDataAfterSave({ appraisalId: data.result.id, xmin: data.result.xmin });
          receivedAppraisalId = data.result.id;
          await submitAttachment(data.result.id, btnEvent);

        } else if (btnEvent == "submit") {
          await submitAttachment(data.result, btnEvent);


        }
        if (attachments.length === 0) {
          setIsSuccess({ isSuccess: true, message: `Appraisal has been ${btnEvent == 'submit' ? 'submitted' : 'saved'}` });
          wait(3000).then(() => {
            navigate("/main/appraisal-form/edit/" + receivedAppraisalId);
          });
        }
      });

    } catch (error) {
      console.log(error);
      setIsError({ isError: true, message: `Appraisal can not be ${btnEvent == 'submit' ? 'submitted' : 'saved'}` });
    } finally {

      setLoading(false);

      if (btnEvent == "submit") {
        handleInvalidClose();

        dispatch(updateappraisalSubmitEvent(false));
        wait(3000).then(() => {
          navigate("/main/dashboard");
          setIsSuccess({ isSuccess: false, message: "" });
          setIsError({ isError: false, message: '' });
        });
      } else {
        wait(3000).then(() => {
          setIsSuccess({ isSuccess: false, message: "" });
          setIsError({ isError: false, message: '' });
        });
      }
    }
  };

  const onSave = () => {
    setIsSaveClicked(true);
    if (selectedInvestment) {
      addDataToDB("save");
    } else {
      setIsError({ isError: true, message: "Please Clear Validation Errors" });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    }
    console.log("selectedInvestment", selectedInvestment);
  };

  function appraisalValuesValidator() {
    var flag = false;
    if (selectedInvestment?.investmentType.toLowerCase() === "equity") {
      flag =
        appraisalsDetailsRDX.currentAppraisalValue != null && appraisalsDetailsRDX.currentAppraisalValue != "" &&
        ((appraisalsDetailsRDX.effectiveDateOfValue != "") as boolean) &&
        ((appraisalsDetailsRDX.sheduled_n_cost != null && appraisalsDetailsRDX.sheduled_n_cost != '') || appraisalsDetailsRDX.sheduled_n_cost?.toString() === "0");
    }
    if (selectedInvestment?.investmentType.toLowerCase() === "debt asset") {
      flag =
        appraisalDetailsForDLorDARDX.currentDebtValue != null && appraisalDetailsForDLorDARDX.currentDebtValue != "" && appraisalDetailsForDLorDARDX.currentPrincipalValue !== null && appraisalDetailsForDLorDARDX.currentPrincipalValue !== "" &&
        ((appraisalDetailsForDLorDARDX.currentEffectiveDate != "") as boolean);
    }
    if (selectedInvestment?.investmentType.toLowerCase() === "mortgage") {
      flag =
        appraisalDetailsForCMRDX.propertyValueAsIs != null && appraisalDetailsForCMRDX.propertyValueAsIs != "" &&
        appraisalDetailsForCMRDX.capRateAsIs != null && appraisalDetailsForCMRDX.capRateAsIs != "" &&
        ((appraisalDetailsForCMRDX.propertyValueAsIsDate != "") as boolean) &&
        ((appraisalDetailsForCMRDX.reportDate != "") as boolean);
    }
    return flag;
  }

  function AssetSumValidator() {
    var flag = false;
    var sum: number = 0;
    if (modifiedAsset.length > 0) {
      modifiedAsset.forEach((asset: AppraisalAssetsModel) => {
        if (asset.currentAppraisalValue != null)
          sum += Number(asset.currentAppraisalValue.toString().replace(/,/g, ""));
      });
    }
    if(selectedInvestment?.investmentType.toLowerCase() == "debt asset"){
      flag = Number(appraisalDetailsForDLorDA.currentDebtValue?.toString().replace(/,/g, "")) === sum;

    }else{
      flag = Number(appraisalsDetailsRDX.currentAppraisalValue?.toString().replace(/,/g, "")) === sum;
    }

    return flag;
  }

  function investmentDetailValidator() {
    var flag = false;
    flag =
      selectedAppraisalFirm.label != "" &&
      selectedAppraiser1.email != "" &&
      selectedExternalAppraiser != "";

    return flag;
  }

  const directRateValidator = () => {
    var flag = false;
    // modifiedAsset.forEach((asset: AppraisalAssetsModel) => {
      var assetWhereNullDirectRate = modifiedAsset.find((asset) => asset.directRate == null || asset.directRate == "")
    // });
    return assetWhereNullDirectRate != undefined ? flag : !flag;
  }

  const onSubmit = () => {
    var invType = latestSelectedInvestment.investmentType !== null ? latestSelectedInvestment.investmentType.toLowerCase() : "";
    var isAppraisalValuesValid = appraisalValuesValidator();
    var assetValidator = modifiedAsset.length > 0 ? AssetSumValidator() : true;
    var isInvestmentDetailValid = investmentDetailValidator();
    var isValuationCasaValid = isValuationTypeRequired ? isValuationTypeRequired && selectedValuationType.value !== "" : true ;
    var isDirectRateValid = invType === "equity" ? directRateValidator() : true ;

    if (
      !isAppraisalValuesValid &&
      !assetValidator &&
      !isInvestmentDetailValid && !isValuationCasaValid
    ) {
      setIsError({
        isError: true,
        message:
          "Please correct the validation errors and The sum of the asset-level values does not equal the investment value. Please reconcile.",
      });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    } else if (!isAppraisalValuesValid || !isInvestmentDetailValid || !isValuationCasaValid || !isDirectRateValid) {
      setIsError({
        isError: true,
        message: "Please correct the validation errors.",
      });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    } else if (!assetValidator) {
      setIsError({
        isError: true,
        message:
          "The sum of the asset-level values does not equal the investment value. Please reconcile.",
      });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    }

    // if(isValuationTypeRequired){
      if (isAppraisalValuesValid && assetValidator && isInvestmentDetailValid && isValuationCasaValid && isDirectRateValid) {
        addDataToDB("submit");
      }
    // }
    // else if (isAppraisalValuesValid && assetValidator && isInvestmentDetailValid) {
    //   addDataToDB("submit");
    // }
    console.log(assetValidator);
    console.log(isAppraisalValuesValid);

    dispatch(updateappraisalSubmitEvent(true));
    console.log(selectedAppraisalFirm);
    console.log(selectedAppraiser1);
  };

  const getLastAppraisalByInvIdAndInvType = (lastAppraisalString: string) => {
    console.log(lastAppraisalString);

    const baseUrl = window.location.origin;
    console.log(baseUrl);
    if (
      selectedInvestment == null ||
      selectedInvestment?.investmentId === "" ||
      selectedInvestment?.investmentType === ""
    ) {
      if (lastAppraisalString == "GetLastPostedAppraisalIdByInv")
        setOpenModel({
          isOpen: true,
          message:
            "Last Appraisal value for the selected investment does not exist",
        });
      if (lastAppraisalString == "GetLastAnnualPostedAprslByInv")
        setOpenModel({
          isOpen: true,
          message:
            "Last Annual Appraisal value for the selected investment does not exist",
        });
    } else {
      try {
        setLoading(true);
        getApiCall(
          AppraisalReviewServiceURL +
          "/appraisals/" +
          lastAppraisalString +
          "?inv=" +
          selectedInvestment.investmentId +
          "&investmentType=" +
          selectedInvestment.investmentType,
          ServiceName.APPRAISALREVIEW
        )
          .then((data: any) => {
            if (data.result.length > 0) {
              const id = data.result;
              const baseUrl = window.location.origin;
              const url = baseUrl + "/main/appraisal-form/view/" + id;
              window.open(url, "_blank");
            } else {
              if (lastAppraisalString == "GetLastPostedAppraisalIdByInv")
                setOpenModel({
                  isOpen: true,
                  message:
                    "Last Appraisal value for the selected investment does not exist",
                });
              if (lastAppraisalString == "GetLastAnnualPostedAprslByInv")
                setOpenModel({
                  isOpen: true,
                  message:
                    "Last Annual Appraisal value for the selected investment does not exist",
                });
            }
          })
          .catch((e: any) => {
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (e: any) {
        console.log(e);
      }
    }
    // setOpenModel({isOpen:true,message:"Hello"});
  };
  const goToViewPendingAppraisal = () => {
    if (latestPendingAppraisal != null) {
      navigate("/main/appraisal-form/view/" + latestPendingAppraisal.appraisalId);
    }
  }
  return (
    <>
      <ArgusSupportBanner />
      {isError.isError && (
        <ToastMessage message={isError.message} severity="error" />
      )}
      {isSuccess.isSuccess && (
        <ToastMessage message={isSuccess.message} severity="success" />
      )}
      <Modal
        open={openModel.isOpen}
        onClose={() => { setOpenModel({ isOpen: false, message: "" }); }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <WarningIcon /> Notification
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {openModel.message}
          </Typography>
        </Box>
      </Modal>
      {isPendingAppraisal && (
        <Card
          sx={{
            width: "100%",
            bgcolor: "#ffae00",//#FFE9C8
            paddingBottom: 1,
            marginBottom: 2,
          }}
        >
          {/*"#FF9800" */}
          <CardContent>
            <WarningIcon sx={{ paddingLeft: 2 }} />
            <b>&nbsp;&nbsp;Invalid Selection</b>

            <IconButton
              style={{ color: "#333" }}
              onClick={handleInvalidClose}
              className="text-right MuiIconButton-sizeLarge"
            >
              <CancelIcon sx={{ fontSize: "35px" }} />
            </IconButton>

            <br />
            <br />
            <Typography sx={{ paddingLeft: 6 }}>
              Appraisal for the selected investment is still in progress. You
              cannot create a new one.
            </Typography>
            <Typography sx={{ paddingLeft: 6 }}>
              Click on button to view existing appraisal for the investment.
            </Typography>
          </CardContent>
          <CardActions>
            <Button sx={{ textTransform: "none", marginLeft: 6 }}
              variant="contained"
              size="medium"
              color="success"
              onClick={goToViewPendingAppraisal}
            >
              <InfoIcon />
              <span>&nbsp;&nbsp;View Appraisal</span>
            </Button>
          </CardActions>
        </Card>
      )}

      <div className="form-wrap">
        {
          <AlertDialog
            isOpen={openDialog}
            handleClose={closeDialog}
            onConfirm={handleConfirm}
            title={"Attention"}
            message={
              "Are you sure that you want to change the investment? It will remove all the uploaded attachments and change appraisal form values."
            }
          />
        }
        <Box sx={{ width: "100%", typography: "body1" }}>
          {loading && (
            <div className="overlaySpinner">
              <CircularProgress />
            </div>
          )}
          {fileMessage && (
            <div className="overlaySpinner">
              {fileMessage && <><span>File upload is in progress... &nbsp;  </span>
                <CircularProgress /></>}
            </div>
          )}

          <Grid container spacing={2}>
            <Grid item xs={6} sm={6}>
              <h3 className="heading">Appraisal Type : {appraisalType}</h3>
            </Grid>
            <Grid item xs={6} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}>
                  {appraisalDetailsFromInvestment.hasDebtLiability && (
                    <Alert
                      severity="info"
                      sx={{
                        justifyContent: "center",
                        marginBottom: 2,
                        padding: 0,
                      }}
                    >
                      {"Debt Liability Associated"}
                    </Alert>
                  )}{" "}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6}>
              <Autocomplete
                clearIcon={null}
                // disabled={isPendingAppraisal}
                id="investment-id"
                options={firstLoadResults.investmentsByUser}
                value={selectedInvestment}
                autoHighlight
                getOptionLabel={(option) => {
                  return option.investmentId + " - " + option.name;
                }}
                sx={{
                  '& .MuiInputLabel-asterisk': {
                    color: 'red',
                  },
                }
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.investmentId} - {option.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    label="Investment"
                    size="small"
                    error={!selectedInvestment && isSaveClicked}
                  />
                )}
                onChange={(event, value) => {
                  handleInvestmentChange(
                    value as unknown as InvestmentIDsModel
                  );
                }}
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <TextField
                required
                InputLabelProps={{
                  sx: {
                    '& .MuiInputLabel-asterisk': {
                      color: 'red',
                    },
                  },
                }}
                label="Fund"
                value={appraisalDetailsFromInvestment.fund}
                variant="outlined"
                size="small"
                fullWidth
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                required
                InputLabelProps={{
                  sx: {
                    '& .MuiInputLabel-asterisk': {
                      color: 'red',
                    },
                  },
                }}
                label="Asset Manager"
                value={(appraisalDetailsFromInvestment.assetManager.firstName != '' && appraisalDetailsFromInvestment.assetManager.lastName != '') ?
                  appraisalDetailsFromInvestment.assetManager.firstName +
                  ", " +
                  appraisalDetailsFromInvestment.assetManager.lastName : ''
                }
                variant="outlined"
                size="small"
                fullWidth
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                required
                InputLabelProps={{
                  sx: {
                    '& .MuiInputLabel-asterisk': {
                      color: 'red',
                    },
                  },
                }}
                label="City/State/Country"
                value={appraisalDetailsFromInvestment.cityStateCountry}
                variant="outlined"
                fullWidth
                size="small"
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <Autocomplete
                clearIcon={null}
                id="appraiser-1"
                sx={{
                  '& .MuiInputLabel-asterisk': {
                    color: 'red',
                  },
                }
                }
                options={appraiser1List || []}
                getOptionLabel={(option) => {
                  return option.firstName + " " + option.lastName;
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.firstName} {option.lastName}
                    {option.userType === "Internal" ? <Badge
                      color="success"
                      sx={{ paddingLeft: "40px" }}
                      badgeContent={option.userType}
                    ></Badge> : <Badge
                      color="warning"
                      sx={{ paddingLeft: "40px" }}
                      badgeContent={option.userType}
                    ></Badge>}

                  </Box>
                )}
                value={selectedAppraiser1}

                onChange={(event, value) =>
                  handleAppraiser1Change(
                    value as unknown as {
                      firstName: string;
                      lastName: string;
                      email: string;
                      name: string;
                      userType: string;
                    }
                  )
                }
                // sx={{ width: 400 }}
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    label={
                      "Appraiser 1 " + `{ ${selectedAppraiser1.userType} User }`
                    }
                    size="small"
                    error={selectedAppraiser1.email === "" && isSubmit}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                required
                InputLabelProps={{
                  sx: {
                    '& .MuiInputLabel-asterisk': {
                      color: 'red',
                    },
                  },
                }}
                label="Investment Type"
                value={appraisalDetailsFromInvestment.investmentType}
                variant="outlined"
                fullWidth
                size="small"
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <Autocomplete
                clearIcon={null}
                id="Appraisal-Firm"
                value={selectedAppraisalFirm}
                getOptionLabel={(option) => {
                  return option.label;
                }}
                options={appraisalFirms}
                // sx={{ width: 400 }}
                sx={{
                  '& .MuiInputLabel-asterisk': {
                    color: 'red',
                  },
                }
                }
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    label="Appraisal Firm"
                    size="small"
                    error={selectedAppraisalFirm.label === "" && isSubmit}
                  />
                )}
                onChange={(event, value) => {
                  handleFirmChangeChange(
                    value as unknown as { label: string; value: string }
                  );
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <Autocomplete
                clearIcon={null}
                id="External-Appraiser"
                options={externalAppraiserArray}
                value={selectedExternalAppraiser}
                onChange={(e, value) => {
                  handleExternalAppraiserChange(value as string);
                }}
                sx={{
                  '& .MuiInputLabel-asterisk': {
                    color: 'red',
                  },
                }
                }
                // sx={{ width: 400 }}
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    label="External Appraiser"
                    size="small"
                    error={!selectedExternalAppraiser && isSubmit}
                  />
                )}
              />
            </Grid>
            {isValuationTypeRequired && (<Grid item xs={6} sm={6}>
              <Autocomplete 
                clearIcon={null}
                id="valuationType"
                //value={selectedValuationType}
                // getOptionLabel={(option) => {
                //   return option.label;
                // }}
                options={ valuationTypeOptions}
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    label="Valuation Type"
                    size="small"
                    error={selectedValuationType.label === "" && isSubmit}
                  />
                )}
                onChange={(event, value) => {
                  handleValuationTypeChange(
                    value as unknown as { label: string; value: string }
                  );
                }}
              />
            </Grid>
            )}
             {isValuationTypeRequired && (<Grid item xs={6} sm={6}>
            </Grid> )}
          </Grid>
        </Box>
        <Divider className="divider-line"></Divider>
        <Box
          sx={{ width: "100%", typography: "body1" }}
          className="accordion-wrap"
        >
          <Accordion defaultExpanded>
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <Typography>Appraisal Value</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {appraisalDetailsFromInvestment.investmentType === "Mortgage" && (
                <AppraisalValuesForCM
                  countriesData={allCountries.current}
                />
              )}
              {appraisalDetailsFromInvestment.investmentType !== "Mortgage" &&
                appraisalDetailsFromInvestment.investmentType !==
                "Debt Asset" && (
                  <AppraisalValueTable
                    countriesData={allCountries.current}
                    openLastAppraisalValue={getLastAppraisalByInvIdAndInvType}
                  />
                )}
              {appraisalDetailsFromInvestment.investmentType ===
                "Debt Asset" && (
                  <AppraisalValueTableForDLorDA
                    countriesData={allCountries.current}
                    openLastAppraisalValue={getLastAppraisalByInvIdAndInvType}
                  />
                )}
            </AccordionDetails>
          </Accordion>
          {appraisalDetailsFromInvestment.investmentType.toLowerCase() !=
            "mortgage" && (
              <Accordion defaultExpanded>
                <AccordionSummary
                  aria-controls="panel2d-content"
                  id="panel2d-header"
                >
                  <Typography>Asset Level Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <DebtAssetsAssetList/> */}
                  {appraisalDetailsFromInvestment.investmentType ===
                    "Debt Asset" ? (
                    <DebtAssetsAssetList />
                  ) : (
                    <AppraisalAssetsList />
                  )}
                </AccordionDetails>
              </Accordion>
            )}

          <Accordion defaultExpanded>
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
            >
              <Typography>Documents</Typography>
            </AccordionSummary>
            <AccordionDetails className="upload-document">
              {documentTypes.length != 0 && (
                <ViewTabList isValuationTypeRequired = {isValuationTypeRequired} tabData={documentTypes} appraisalType={appraisalType} />
              )}
            </AccordionDetails>
          </Accordion>
        </Box>
        <Box sx={{ padding: "15px 2px" }}>
          <Grid item xs={12}>
            <Button sx={{ textTransform: "none" }}
              onClick={onSave}
              variant="contained"
              size="medium"
              color="success"
              disabled={!selectedInvestment || isPendingAppraisal}
            >
              Save
            </Button>
            <Button sx={{ textTransform: "none", ml: 2 }}
              variant="outlined"
              size="medium"
              color="error"
              onClick={() => navigate("/main/dashboard")}
            >
              Close
            </Button>
            <Button sx={{ textTransform: "none" }}
              variant="contained"
              size="medium"
              color="primary"
              className="text-right"
              onClick={onSubmit}
              disabled={!selectedInvestment as boolean || isPendingAppraisal}
            >
              Submit
            </Button>
          </Grid>
        </Box>
      </div>
    </>
  );
};
